var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"gmap",staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"map-type-id":"terrain"},on:{"bounds_changed":_vm.updateBounds}})
}
var staticRenderFns = []

export { render, staticRenderFns }